module.exports = __webpack_public_path__ + "static_pc/img/24.8a024488.png";